import { cacheExchange, createClient } from 'urql';
import { Client as WSClient } from 'graphql-ws';

import { AuthClient } from '@appcues/auth';
import { setupExchanges } from './setup-exchanges';

function getLocalFeature(feature: string) {
  const stored = localStorage.getItem('appcues:devtools:features');
  const overrides = stored ? JSON.parse(stored) : {};
  return overrides[feature] ?? false;
}

function getAnalyticsBackend() {
  if (getLocalFeature('FORCE_CLICKHOUSE')) {
    return 'ch';
  }
  if (getLocalFeature('FORCE_SNOWFLAKE')) {
    return 'sf';
  }
  return null;
}

export default function createGraphQLClient(
  auth: AuthClient,
  wsClient?: WSClient,
  baseUrl = import.meta.env.CUSTOMER_API_URL
) {
  /* Someday you may think to yourself 'we should use optimistic updates with this mutation, that
  would be smart and prevent unnecessarily refetching data'. You would be right. However, to use urql's
  optimistic updates, you would need to import the cacheExchange from the @urql/exchange-graphcache
  package which changes urql from using a document cache to using a normalized cache. The normalized
  cache requires writing cache update functions or otherwise changing the responses of all of studio5's
  create and delete mutations. Until we're ready to do that work, we can not make use of optimistic updates
  in studio5. Just letting you know. Details can be seen in the docs here:
  https://commerce.nearform.com/open-source/urql/docs/graphcache/cache-updates/#why-do-we-need-cache-updates)
  */
  const exchanges = setupExchanges(auth, { cacheExchange, wsClient });
  const analyticsBackend = getAnalyticsBackend();

  return createClient({
    url: `${baseUrl}/v1/graphql`,
    exchanges,
    fetchOptions: () => ({
      headers: {
        ...(analyticsBackend && {
          'force-analytics': analyticsBackend,
        }),
      },
    }),
  });
}
